<template>
  <div class="box keypost">
    <div class="box-head bg-color1 felx-between">
      <div class="box-head-title color1 flex-algin">
        关键岗位 &nbsp;&nbsp;&nbsp;&nbsp;
        <!-- <i class="el-icon-arrow-down color1" style="margin-left:10px;"></i> -->
      </div>
      <el-date-picker
        v-model="opt.month"
        value-format="yyyy-MM"
        type="month"
        @change="doFilter"
        placeholder="选择月"
      ></el-date-picker>
    </div>
    <div class="box-total">
      <div class="box-total-cell" v-for="item in attendCell" :key="item.id">
        <div class="box-total-item bg-color5 color1" @click="setMid(item.id)">
          <p class="name">{{item.name}}</p>
          <p class="set">出勤率{{item.bilv}}%/月</p>
          <label class="setting-lab" @click="setAttend(item.id)">
            <i class="el-icon-s-tools set-icon"></i>
          </label>
          <span v-if="opt.type==item.id" class="slectBorder"></span>
        </div>
      </div>
      <!-- <div class="box-total-cell">
            <div class="box-total-item bg-color5 color2" @click="setMid(2)">
                <p class="name">监理单位-总监工程师</p>
                <p class="set">出勤率{{opt.attend}}%/月</p>
                <label class="setting-lab" @click="setAttend(2)">
                    <i class="el-icon-s-tools set-icon"></i>
                </label>
                <span v-if="opt.type==2" class="slectBorder"></span>
            </div>
        </div>
        <div class="box-total-cell">
            <div class="box-total-item bg-color5 color2" @click="setMid(3)">
                <p class="name">监理单位-总监代表</p>
                <p class="set">出勤率{{opt.attend}}%/月</p>
                <label class="setting-lab" @click="setAttend(3)">
                    <i class="el-icon-s-tools set-icon"></i>
                </label>
                <span v-if="opt.type==3" class="slectBorder"></span>
            </div>
        </div>
        <div class="box-total-cell">
            <div class="box-total-item bg-color5 color2" @click="setMid(4)">
                <p class="name">施工单位-专职安全员</p>
                <p class="set">出勤率{{opt.attend}}%/月</p>
                <label class="setting-lab" @click="setAttend(4)">
                    <i class="el-icon-s-tools set-icon"></i>
                </label>
                <span v-if="opt.type==4" class="slectBorder"></span>
            </div>
        </div>
        <div class="box-total-cell">
            <div class="box-total-item bg-color5 color2" @click="setMid(5)">
                <p class="name">施工单位-技术负责人</p>
                <p class="set">出勤率{{opt.attend}}%/月</p>
                <label class="setting-lab" @click="setAttend(5)">
                    <i class="el-icon-s-tools set-icon"></i>
                </label>
                <span v-if="opt.type==5" class="slectBorder"></span>
            </div>
      </div>-->
    </div>
    <div class="box-table">
      <el-table
        :data="tableList"
        height="100%"
        style="width: 100%;border:0;height:100%;"
        :header-cell-class-name="tableHeadCellName"
        :header-row-class-name="tableHeadRowName"
        :row-class-name="tableRowClassName"
        :default-sort = "{prop: 'monthAttendance', order: 'descending'}"
        stripe
      >
        <el-table-column prop="projectName" label="项目" align="center"></el-table-column>
        <el-table-column prop="name" label="岗位" align="center">
          <template slot-scope="scope">
            <span >{{scope.row.positionName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="personName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="monthAttendCount" label="累计出勤" align="center"></el-table-column>
        <el-table-column prop="monthAttendance" label="出勤率" align="center" sortable>
          <template slot-scope="scope">
            <span :class="scope.row.over?'color2':'color3'" >{{scope.row.monthAttendance}}%</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" class="bg-color4" v-if="scope.row.over">达标</el-button>
            <el-button size="mini" type="danger" class="bg-color3" v-else>未达标</el-button> -->
            <el-button size="mini" @click="personInfo(scope.$index, scope.row)">考勤信息</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="width:100%;">
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
        style="padding-top:10px;"
      ></el-pagination> -->
    </div>
    <!-- 考勤天数新增窗口 -->
    <el-dialog
      title="输入月份和出勤率"
      :visible.sync="setAttendVisible"
      custom-class="dialog-keyPost"
      center
      width="300px"
      :append-to-body="true"
      :lock-scroll="false"
    >
      <el-form label-position="left" ref="opt" label-width="120px" :model="opt">
        <el-form-item label="选择考勤率">
          <el-select v-model="opt.attend" placeholder="请选择">
            <el-option
              v-for="item in attends"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div style="width:60%;margin:20px auto">
          <el-button @click="setAttendVisible=false">取消</el-button>
          <el-button type="primary" @click="onSubmitMoney">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
  data() {
    return {
      tableList: [],
      tableHeadCellName: 'table-head-cell',
      tableHeadRowName: 'table-head-row',
      opt: {
        month: util.myTime.formatTime(new Date(), 'YYYY-MM'), //当前时间
        type: 1, // 当前岗位
        attend: '60' //当前出勤率
      },
      attendCell: [
        { id: '1', bilv: '60', name: '施工单位-项目经理' },
        { id: '2', bilv: '60', name: '监理单位-总监工程师' },
        { id: '3', bilv: '60', name: '监理单位-总监代表' },
        { id: '6', bilv: '60', name: '检测单位-检测负责人' },
        // { id: '4', bilv: '60', name: '施工单位-专职安全员' },
        // { id: '5', bilv: '60', name: '施工单位-技术负责人' }
      ],
      curAttendCell: '1',
      setAttendVisible: false,
      // numForm:{
      //     attend:'60'  //当前出勤率
      // },
      attends: [
        { label: '20%', value: '20', id: '1' },
        { label: '30%', value: '30', id: '2' },
        { label: '50%', value: '50', id: '3' },
        { label: '60%', value: '60', id: '4' },
        { label: '70%', value: '70', id: '5' },
        { label: '80%', value: '80', id: '6' },
        { label: '90%', value: '90', id: '7' },
        { label: '100%', value: '100', id: '8' }
      ],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      joinType:'',
    }
  },
  mounted() {
    if(util.session.get('token')){
      this.groupId = this.$store.state.groupId
      this.joinType = util.session.get('roleId')=='3'?"3":'2'
      if ('' == this.groupId || undefined == this.groupId) {
        this.groupId = util.session.get('groupId')
      }
      this.attendCell =
        JSON.parse(util.localSession.get('keypost')) || this.attendCell
      //this.getDataNum()
      this.getData()  
    }
  },
  methods: {
    doFilter() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //获取数据列表
    getData() {
      var that = this
      for (var i = 0; i < this.attendCell.length; i++) {
        if (this.attendCell[i].id == this.opt.type) {
          this.opt.attend = this.attendCell[i].bilv
        }
      }
      myHttp
        .findKeyPositionsListByEntId({
          entId: this.groupId,
          positionType: this.opt.type,
          monthDate: this.opt.month,
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data|| []
            var result = []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].over =
                parseInt(list[i].monthAttendance) >= parseFloat(that.opt.attend)
                  ? true
                  : false
              result.push(list[i])
            }
            // if(result.length==0){
            //   result = [{},{},{},{},{},{},{}]
            // }
            that.tableList = result
            if (that.totalItems == 0) {
              // that.totalItems = resp.data.data.pageInfo.total
            }
          } else {
          }
        })
    },
    //获取数据统计
    getDataNum() {
      var that = this
      myHttp
        .findKeyPositionsCountByEntId({
          rate: this.opt.attend,
          workType: this.opt.type,
          attendanceTime: this.opt.month,
          entId: this.groupId,
          loginPlatform: this.joinType
        })
        .then(function(resp) {
          //console.log(resp)
        })
    },
    //
    tableRowClassName({ row, rowIndex }) {
      // if (rowIndex%2 === 0) {
      // return 'full-row';
      // } else if (rowIndex%2 === 1) {
      // return 'null-row';
      // }
      return 'full-row'
    },
    //跳转详情
    toInfo() {
      //this.$router.push({ path: '/tqmInfo' })
    },
    onSubmitMoney() {
      this.setAttendVisible = false
      for (var i = 0; i < this.attendCell.length; i++) {
        if (this.attendCell[i].id == this.curAttendCell) {
          this.attendCell[i].bilv = this.opt.attend
        }
      }
      this.opt.type = this.curAttendCell
      var obj = JSON.stringify(this.attendCell)
      util.localSession.set('keypost', obj)
      this.getData()
    },
    //设置考勤率
    setAttend(index) {
      // this.workType = index
      this.curAttendCell = index
      this.setAttendVisible = true
    },
    //当前查看
    setMid(index) {
      this.opt.type = index
      this.getData()
    },

    //考勤详情
    personInfo(index,row){
      util.session.set('proId',row.projectId)
      var id = row.personId
      if(util.session.get('roleId')=='3'){
        this.$router.push({name: 'workerInfoEnt',params: { id: row.personId }})
      }else{
        this.$router.push({name: 'workerInfoCompany',params: { id: row.personId }})
      }
      
    },

  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.box {
  width: 100%;
  position: relative;
  height: calc(100vh - 170px);
  background: #fff;
}
.box-head {
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  padding: 0 20px;
}
.box-table {
  width: 100%;
  height: calc(100% - 230px);
  position: relative;
  /* overflow: auto; */
}
.el-table .box-head-title {
  font-size: 16px;
}
.box-total {
  width: 100%;
  padding: 20px;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
}
.box-total-cell {
  width: 20%;
  padding: 0 50px;
}
.box-total-item {
  width: 100%;
  height: 100px;
  position: relative;
  border-radius: 6px;
  cursor: pointer;
}
.box-total-item p {
  padding: 10px;
}
.box-total-item .name {
  font-size: 18px;
}
.box-total-item .set {
  font-size: 14px;
}
.setting-lab {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 8px;
  right: 10px;
  cursor: pointer;
}
.setting-lab .set-icon {
  font-size: 24px;
  color: #0085ff;
}

.flex-algin {
  display: flex;
  align-content: center;
  align-items: center;
}
.felx-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bg-color1 {
  background: #f5f5f5;
}
.bg-color2 {
  background: #0d2dff;
}
.bg-color3 {
  background: #ffbc01;
}
.bg-color4 {
  background: #36c635;
}
.bg-color5 {
  background: #f5f5f5;
}
.color1 {
  color: #17b2fe;
}
.color2 {
  color: #36c635;
}
.color3 {
  color: red;
}
/* .color2 {
  color: #4c9aff;
} */
.slectBorder {
  width: 100%;
  height: 8px;
  background: #36c635;
  border-radius: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
<style>
.keypost .el-table .table-head-cell,
.keypost .table-head-row {
  background: #fff;
  color: #4c9aff;
  font-size: 18px;
  text-align: center;
}
.keypost .el-table .full-row {
  /* background: #031260 !important; */
  color: #4c9aff;
  font-size: 18px;
  text-align: center;
}
.keypost .el-table .null-row {
  background: #010d27 !important;
  border: 0;
  height: 10px;
}
.keypost .el-table .el-table__empty-block {
  /* background: #031260; */
  color: #4c9aff;
  font-size: 18px;
  border: 0;
}
.keypost .el-table td,
.keypost .el-table th.is-leaf {
  border: 0;
  border-bottom: 10px solid #f5f5f5;
}
.keypost .el-table--enable-row-hover .el-table__body tr:hover > td,
.keypost .el-table,
.keypost .el-table__expanded-cell {
  background-color: inherit;
}
.keypost .el-row {
  width: 100%;
  box-sizing: border-box;
}
.keypost .el-input__inner {
  background: transparent;
  border: 0;
  color: #4c9aff;
}
.keypost .el-pagination span {
  color: #fff;
}
/* .dialog-keyPost{
        background: #031260;
        color: #4C9AFF;
    }
    .dialog-keyPost .el-dialog__title,.dialog-keyPost .el-form-item__label{
        color: #4C9AFF;
    }
    .dialog-keyPost .el-input__inner{
        background: rgba(112, 112, 112, 0.3);
        border: 0;
        color: #4C9AFF;
    } */
</style>